"use client";
import { Box, Popover, Popper, useTheme } from "@mui/material";
import { PropsWithChildren, useState, MouseEvent } from "react";
import {
  DateRangePicker as _DateRangePicker,
  DateRangePickerProps as _DateRangePickerProps,
} from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";

interface DateRangePickerProps extends _DateRangePickerProps {}

export interface Range {
  startDate?: Date | undefined;
  endDate?: Date | undefined;
  color?: string | undefined;
  key?: string | undefined;
  autoFocus?: boolean | undefined;
  disabled?: boolean | undefined;
  showDateDisplay?: boolean | undefined;
}

export const DateRangePicker = ({
  children,
  ...props
}: PropsWithChildren<DateRangePickerProps>) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Box onClick={handleClick}>{children}</Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClick}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        elevation={1}
        sx={{
          overflow: "hidden",
        }}
        slotProps={{
          paper: {
            sx: { borderRadius: "0.8rem" },
          },
        }}
      >
        <Box
          sx={{
            fontFamily: theme.typography.fontFamily,
            "& .rdrStaticRangeLabel": {
              fontFamily: theme.typography.fontFamily,
            },
          }}
          component={_DateRangePicker}
          rangeColors={[theme.palette.primary.main]}
          onShownDateChange={(e) => {
            console.log(e, "change");
          }}
          {...props}
        />
      </Popover>
    </>
  );
};
